<template>
  <div class="conseil-container">
    <div class="v-title">{{ title }}</div>
    <div class="content"><VShowdown :source="content"/></div>
  </div>
</template>

<script>
import { contentFullApi } from "../../../utils/contentful";

export default {
  name: "ConseillerDetails",
  data() {
    return {
      content: "",
      title: ""
    };
  },
  mounted() {
    contentFullApi
      .getEntries({
        "fields.slug": this.$route.params.page,
        content_type: "conseillerItem"
      })
      .then(d => {
        this.content = d.items[0].fields.content;
        this.title = d.items[0].fields.title;
      });
  }
};
</script>

<style scoped>
.content {
  line-height: 1.5;
  font-family: "Roboto Slab";
  font-size: 17px;
}
p {
  word-break: break-word;
}

.v-title {
  font-family: "Roboto Slab";
  color: #ef6c00;

  font-size: 50px;
  margin-bottom: 0.5em;
}
.conseil-container {
  max-width: 700px;
  margin: auto;
  margin-top: 3em;
  padding:1em;
}
</style>
